export default __webpack_public_path__ + "static/media/whatsapp.29a8e4bf.png";